import {FaqDto, MenuDto} from 'src/services/Client';
import {IReduxState} from "../IReduxState";

export const selectSupportArealinks = (state: any): MenuDto | undefined =>
  state.support.supportAreaLinks;

export const selectActiveFaqs = (state: IReduxState): FaqDto[] =>
    state.support.activeFaqs;



// WEBPACK FOOTER //
// ./src/redux/selectors/supportSelectors.ts